import React from "react";
import Image1 from "../../../assets/article1.png";
import Image2 from "../../../assets/article2.png";
import Image3 from "../../../assets/article3.png";

const Articles = () => {
  const data = [
    {
      image: Image1,
      tags: ["DEFI", "CRYPTO"],
      desc: "How Defi is Changing the world through Farming?",
      link: "",
    },
    {
      image: Image2,
      tags: ["BITCOIN"],
      desc: "How Bitcoin is becoming the daily currency?",
      link: "",
    },
    {
      image: Image3,
      tags: ["CRYPTO"],
      desc: "How Production of NFT boosts the Defi Market?",
      link: "",
    },
  ];
  return (
    <section className="py-20">
      <div className="container">
        {" "}
        <h2 className=" text-[30px] md:text-[44px] font-semibold">
          Engaging <span className="text-primary "> Articles</span>
        </h2>
        <p className="text-gray max-w-md text-base md:text-lg mt-3 ">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mi suscipit
          in elementum nunc
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-10">
          {data.map((val, i) => (
            <div className=" border-2 border-[#262626] p-4 rounded-xl" key={i}>
              <div className="rounded-xl overflow-hidden">
                <img src={val.image} alt="" className="w-full" />
              </div>
              <div className="pt-4 pb-2">
                <div className=" grid grid-flow-col justify-start gap-4 items-center">
                  {val.tags.map((tag, i) => (
                    <div className="bg-[#232323] text-sm text-gray py-1.5 px-3 rounded-md">
                      {tag}
                    </div>
                  ))}
                </div>
                <p className="text-gray text-base md:text-xl mt-4 ">
                  {val.desc}
                </p>
                <div className=" bg-[#262626] my-4  w-full h-[2px]" />
                <button className="text-center max-w-max text-gray mx-auto block text-sm">
                  READ MORE
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Articles;
